import ApiHandler from "./ApiHandler";

const ScoreCriterion = {
  getTypes: async () => await ApiHandler.i.auth().get('/score-criterion/type'),
}

export default ScoreCriterion;
